<div class="form-container" *ngIf="totalItems === 0 || totalItems > 0" id="top">
  <div *ngIf="!isLoading">
    <div class="col-12 row heading">
      <!-- <div class="col-lg-6 results-heading"> -->
      <div class="results-heading-title">
        <div class="title">{{ 'STOCK_COUNT.FILTER_RESULTS.TITLE_FIRST_PART' | translate }}</div>
        <div class="subtitle">{{ 'STOCK_COUNT.FILTER_RESULTS.TITLE_SECOND_PART' | translate }}</div>
      </div>
      <div class="results-actions-block">
        <div class="results-heading-text">
          <div class="count">
            <span *ngIf="totalItems > 1 || totalItems === 0">{{ 'STOCK_COUNT.COUNT' | translate: { count: totalItems } }}</span>
            <span *ngIf="totalItems === 1">{{ 'STOCK_COUNT.COUNT_1' | translate }}</span>
          </div>
          <div class="count-postscript">
            {{ 'STOCK_COUNT.COUNT-POSTSCRIPT' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="row col-12 pagination" *ngIf="!isLoading && totalItems > 0">
      <app-pager [itemsPerPage]="filter.pageSize" (pageChange)="onPageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-pager>
    </div>

    <div class="col-12 row bottom-line bold show-from-sm sorters" *ngIf="totalItems > 0">
      <span class="sorter col-md col-container" sortable-header="stockCountDate" [sortField]="sortField" [sortAscending]="sortAscending" [sortFn]="sortBnd">{{
        'STOCK_COUNT.LABELS.COUNT' | translate
      }}</span>
      <span class="sorter col-md col-container" sortable-header="stockCountNo" [sortField]="sortField" [sortAscending]="sortAscending" [sortFn]="sortBnd">{{
        'STOCK_COUNT.LABELS.NR' | translate
      }}</span>
      <span class="sorter col-md col-container" sortable-header="shipTo" [sortField]="sortField" [sortAscending]="sortAscending" [sortFn]="sortBnd">{{
        'STOCK_COUNT.LABELS.SHIPTO' | translate
      }}</span>
    </div>

    <div
      *ngFor="
        let stockCount of stockCounts
          | paginate
            : {
                itemsPerPage: filter.pageSize,
                currentPage: filter.pageNumber,
                totalItems: totalItems
              }
      "
      class="row col-12 striped cell soft-line order"
      [ngClass]="{ cancelled: stockCount.orderStatus === '03' }"
    >
      <div class="col-md-12 order_line" (click)="openStockCount.emit(stockCount)">
        <div class="col-md col-container">
          {{ stockCount.stockCountDate | date: dateFormat }}
        </div>
        <div class="col-md col-container">
          {{ stockCount.stockCountNo }}
        </div>
        <div class="col-md col-container">
          {{ mapShipTos(stockCount.shipTo) }}
        </div>

        <div class="order_data-menu more_ellipsis"></div>
      </div>
    </div>
  </div>
  <div class="loading_spinner" *ngIf="isLoading">
    <i class="fa fa-spinner fa-pulse fa-fw"></i>
  </div>

  <div class="row col-12 pagination" *ngIf="!isLoading && totalItems > 0">
    <app-pager [itemsPerPage]="filter.pageSize" (pageChange)="onPageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-pager>
  </div>
</div>
